import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import React from 'react'
import { Modal } from 'react-bootstrap'
import moment from 'moment-timezone'
import Loading from '../../Component/Loading'
import useTableSorting from '../../Hooks/useTableSorting'
import { useEffect, useState } from 'react'
import { SUGAR_READING_LIST, BP_READING_LIST } from '../Repository/PatientRepo'
import { Peginationcomponent } from '../../Component/Peginationcomponent';
import { NoRecordFound } from '../../Component/NoRecordFound';
import { useParams } from 'react-router-dom'
import { RoleTitle } from '../../Context/constants';
import useReduxData from '../../Hooks/useReduxData'

const MeterVitals = ({ type }) => {

    const [count, setCount] = useState(0)
    const [controller, setController] = useState({ page: 1, rowsPerPage: 10 });
    const { id, subpatientId } = useParams()
    const { reduxData: userData } = useReduxData("userDataRDX")
    const { reduxData: MemberType, } = useReduxData("SubMemberTypeRDX")
    const [openModal, setOpenModal] = useState({
        viewMeterVitals: false,
        data: null
    })

    const handleClosedModal = (type) => {
        setOpenModal((pre) => ({
            ...pre,
            data: null,
            [type]: false
        }))
    }

    const handleOpenModal = (type, data) => {
        setOpenModal((prev) => ({
            ...prev,
            data,
            [type]: true,
        }));
    };

    const [sugarReadingData, setSugarReadingData] = useState([]);
    const [bpReadingData, setBpReadingData] = useState([]);

    const sugarHeadCells = [
        { id: "#", numeric: false, disablePadding: true, label: "#", showIcon: true },
        { id: "meterName", numeric: false, disablePadding: true, label: "Meter Name", showIcon: true },
        { id: "date", numeric: false, disablePadding: true, label: "Date", showIcon: true },
        { id: "time", numeric: true, disablePadding: false, label: "Time" },
        { id: "sugarReading", numeric: true, disablePadding: false, label: "Sugar Reading", showIcon: true },
        { id: "when", numeric: true, disablePadding: false, label: "When", showIcon: true },
        { id: "duration", numeric: false, disablePadding: false, label: "Duration", showIcon: true },
        { id: "remarks", numeric: false, disablePadding: false, label: "Remarks", showIcon: true },
        { id: "action", numeric: false, disablePadding: false, label: "Action", showLeft: true }
    ];

    const bpHeadCells = [
        { id: "#", numeric: false, disablePadding: true, label: "#", showIcon: true },
        { id: "meterName", numeric: false, disablePadding: true, label: "Meter Name", showIcon: true },
        { id: "date", numeric: false, disablePadding: true, label: "Date", showIcon: true },
        { id: "time", numeric: true, disablePadding: false, label: "Time" },
        { id: "systolic", numeric: true, disablePadding: false, label: "Systolic", showIcon: true },
        { id: "diastolic", numeric: true, disablePadding: false, label: "Diastolic", showIcon: true },
        { id: "pulse", numeric: false, disablePadding: false, label: "Pulse", showIcon: true },
        { id: "action", numeric: false, disablePadding: false, label: "Action", showLeft: true }
    ];

    const {
        EnhancedTableHead: EnhancedTableSugar,
        order: orderSugar,
        orderBy: orderBySugar,
        stableSort: stableSortSugar,
        getComparator: getComparatorSugar,
        handleRequestSort: handleRequestSortSugar,
    } = useTableSorting(sugarHeadCells)

    const {
        EnhancedTableHead: EnhancedTableBP,
        order: orderBP,
        orderBy: orderByBP,
        stableSort: stableSortBP,
        getComparator: getComparatorBP,
        handleRequestSort: handleRequestSortBP,
    } = useTableSorting(bpHeadCells)


    const [loader, setLoader] = useState(false)
    const [tab, setTab] = useState(1)

    const ChangeTab = (Type) => {
        switch (Type) {
            case "Sugar":
                setTab(1)
                break;
            case "BP":
                setTab(2)
                break;
            default: setTab(1)
        }
    }

    const getSugarMeterVitals = async () => {
        setLoader(true)
        let payload = {
            providerId: (userData.roleTitle === RoleTitle.STAFF || userData.roleTitle === RoleTitle.FRONT_DESK) ? userData?.providerId : userData?.userId,
            patientId: type === "Patients" ? id : MemberType ? subpatientId : subpatientId,
            staffId: userData.roleTitle === RoleTitle.STAFF ? userData?.userId : undefined,
            frontdeskId: userData.roleTitle === RoleTitle.FRONT_DESK ? userData?.userId : undefined,
            roleTitle: userData.roleTitle,
            page: controller.page,
            count: controller.rowsPerPage,
        }
        try {
            let response = await SUGAR_READING_LIST(payload)
            const sugarReadingData = response?.data.map(sugarData => ({
                ...sugarData
            }));
            setSugarReadingData(sugarReadingData)
            setLoader(false)
            setCount(response.totalCount)
        } catch (error) {
            setSugarReadingData([])
            setCount(0)
            setLoader(false)
        }

    }

    const getBpMeterVitals = async () => {
        setLoader(true)
        let payload = {
            providerId: (userData.roleTitle === RoleTitle.STAFF || userData.roleTitle === RoleTitle.FRONT_DESK) ? userData?.providerId : userData?.userId,
            patientId: type === "Patients" ? id : MemberType ? subpatientId : subpatientId,
            staffId: userData.roleTitle === RoleTitle.STAFF ? userData?.userId : undefined,
            frontdeskId: userData.roleTitle === RoleTitle.FRONT_DESK ? userData?.userId : undefined,
            roleTitle: userData.roleTitle,
            page: controller.page,
            count: controller.rowsPerPage,
        }
        try {
            let response = await BP_READING_LIST(payload)
            const bpReadingData = response?.data.map(bpData => ({
                ...bpData
            }));
            setBpReadingData(bpReadingData)
            setLoader(false)
            setCount(response.totalCount)
        } catch (error) {
            setBpReadingData([])
            setCount(0)
            setLoader(false)
        }

    }

    useEffect(() => {
        if (tab === 1) {
            getSugarMeterVitals()
        }
        if (tab === 2) {
            getBpMeterVitals()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tab, controller])


    return (
        <>
            {loader && <Loading />}
            <div className="">
                <div className="row px-1">
                    <div className="col-12 px-0 mt-3 d-flex justify-content-between pb-3" style={{ borderBottom: "2px solid #ededed" }}>
                        <ul className="nav  mb-0  ">
                            <li className="nav-item" role="presentation">
                                <button className={`teams_frofile_stepper_btn me-2 ${tab === 1 && "active_teams_frofile"}`} id="personal" type="button" onClick={() => ChangeTab("Sugar")} >Blood Sugar Vitals</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className={`teams_frofile_stepper_btn ${tab === 2 && "active_teams_frofile"}`} id="education" type="button" onClick={() => ChangeTab("BP")} >Blood BP Vitals</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {tab === 1 &&
                <div className="row mt-3 ">
                    <div className=" d-flex flex-column justify-content-between " style={{ height: "100%" }}>
                        <div>
                            <TableContainer >
                                {sugarReadingData?.length === 0 &&
                                    <div className="col-sm-12 mt-3 text-center " >  <NoRecordFound />  </div>
                                }
                                <Table
                                    id="table_mui"
                                    aria-labelledby="tableTitle"
                                    size={"medium"}
                                    aria-label="enhanced table"
                                >
                                    {
                                        sugarReadingData.length !== 0 && <EnhancedTableSugar order={orderSugar} orderBy={orderBySugar} onRequestSort={handleRequestSortSugar} rowCount={sugarReadingData.length} />
                                    }
                                    <TableBody>

                                        {
                                            stableSortSugar(sugarReadingData, getComparatorSugar(orderSugar, orderBySugar)).map(
                                                (row, index) => {
                                                    const labelId = `enhanced-table-checkbox-${index}`;
                                                    return <React.Fragment key={index}><TableRow hover id="hover_tr" >
                                                        <TableCell className="ps-3" id={labelId} scope="row" padding="none" >
                                                            {index + 1}
                                                        </TableCell>
                                                        <TableCell className="ps-3" id={labelId} scope="row" padding="none" >
                                                            {row?.meterName ? row?.meterName : "N/A"}
                                                        </TableCell>

                                                        <TableCell id={labelId}>
                                                            {row?.date
                                                                ? moment(row?.date).tz(userData?.timezoneName || moment.tz.guess()).format('ll')
                                                                : 'N/A'}
                                                        </TableCell>
                                                        <TableCell id={labelId} align="left">
                                                            {(row?.date)
                                                                ? moment(row?.date).tz(userData?.timezoneName || moment.tz.guess()).format('LT')
                                                                : 'N/A'}
                                                        </TableCell>
                                                        <TableCell id={labelId} align="left">{row?.sugarReading} mg/dL</TableCell>

                                                        <TableCell id={labelId} align="left">{row?.when === "before" ? "Before Food" : row?.when === "after" ? "After Food" : ""}</TableCell>
                                                        <TableCell id={labelId} align="left">{row?.duration} min</TableCell>
                                                        <TableCell id={labelId} align="left">{row?.remarks ? <span
                                                            style={{
                                                                display: "inline-block",
                                                                maxWidth: "150px",
                                                                whiteSpace: "normal",
                                                                wordBreak: "break-word"
                                                            }}
                                                        >
                                                            {row?.remarks}
                                                        </span> : "N/A"}</TableCell>
                                                        <TableCell id={labelId} align="right">
                                                            <i className="fa-solid fa-eye  all_icons_color me-2 fs-6" style={{ cursor: "pointer" }} onClick={() => handleOpenModal("viewMeterVitals", row)}></i>
                                                        </TableCell>
                                                    </TableRow>
                                                    </React.Fragment>
                                                }
                                            )
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                        <div className='w-100 3'>
                            {count > 10 && <Peginationcomponent count={count} controller={controller} setController={setController} />}
                        </div>
                    </div>
                </div>
            }
            {tab === 2 &&
                <div className="row mt-3 ">
                    <div className=" d-flex flex-column justify-content-between " style={{ height: "100%" }}>
                        <div>
                            <TableContainer >
                                {bpReadingData?.length === 0 &&
                                    <div className="col-sm-12 mt-3 text-center " >  <NoRecordFound />  </div>
                                }
                                <Table
                                    id="table_mui"
                                    aria-labelledby="tableTitle"
                                    size={"medium"}
                                    aria-label="enhanced table"
                                >
                                    {
                                        bpReadingData.length !== 0 && <EnhancedTableBP order={orderBP} orderBy={orderByBP} onRequestSort={handleRequestSortBP} rowCount={bpReadingData.length} />
                                    }
                                    <TableBody>

                                        {
                                            stableSortBP(bpReadingData, getComparatorBP(orderBP, orderByBP)).map(
                                                (row, index) => {
                                                    const labelId = `enhanced-table-checkbox-${index}`;
                                                    return <React.Fragment key={index}><TableRow hover id="hover_tr" >
                                                        <TableCell className="ps-3" id={labelId} scope="row" padding="none" >
                                                            {index + 1}
                                                        </TableCell>
                                                        <TableCell className="ps-3" id={labelId} scope="row" padding="none" >
                                                            {row?.meterName ? row?.meterName : "N/A"}
                                                        </TableCell>

                                                        <TableCell id={labelId}>
                                                            {row?.date
                                                                ? moment(row?.date).tz(userData?.timezoneName || moment.tz.guess()).format('ll')
                                                                : 'N/A'}
                                                        </TableCell>
                                                        <TableCell id={labelId} align="left">
                                                            {(row?.date)
                                                                ? moment(row?.date).tz(userData?.timezoneName || moment.tz.guess()).format('LT')
                                                                : 'N/A'}
                                                        </TableCell>
                                                        <TableCell id={labelId} align="left">{row?.sys}</TableCell>

                                                        <TableCell id={labelId} align="left">{row?.dia}</TableCell>
                                                        <TableCell id={labelId} align="left">{row?.pulse}</TableCell>
                                                        <TableCell id={labelId} align="right">
                                                            <i className="fa-solid fa-eye  all_icons_color me-2 fs-6" style={{ cursor: "pointer" }} onClick={() => handleOpenModal("viewMeterVitals", row)}></i>
                                                        </TableCell>
                                                    </TableRow>
                                                    </React.Fragment>
                                                }
                                            )
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                        <div className='w-100 3'>
                            {count > 10 && <Peginationcomponent count={count} controller={controller} setController={setController} />}
                        </div>
                    </div>
                </div>
            }

            <Modal
                show={openModal?.data && openModal?.viewMeterVitals}
                onHide={() => handleClosedModal("viewMeterVitals")}
                centered
            >
                <Modal.Body>
                    <div className="modal-body viewdetail">
                        <div className="text-center">
                            <h4 className="modal-title mb-3" >Meter Vitals</h4>
                        </div>
                        <div className="row">
                            <div className="col-sm-6">
                                <label className="form-label mb-0">Meter Name</label>
                                <p>{openModal?.data?.meterName || "N/A"}</p>
                            </div>
                            <div className="col-sm-6">
                                <label className="form-label mb-0">Date</label>
                                <p> {openModal?.data?.date ? moment(openModal?.data?.date).tz(userData?.timezoneName || moment.tz.guess()).format('ll') : "N/A"}</p>
                            </div>
                            <div className="col-sm-6">
                                <label className="form-label mb-0">Time</label>
                                <p> {openModal?.data?.date ? moment(openModal?.data?.date).tz(userData?.timezoneName || moment.tz.guess()).format('LT') : "N/A"}</p>
                            </div>
                            {tab === 1 && (
                                <>
                                    <div className="col-sm-6">
                                        <label className="form-label mb-0">Sugar Reading</label>
                                        <p> {openModal?.data?.sugarReading} mg/dL </p>
                                    </div>
                                    <div className="col-sm-6">
                                        <label className="form-label mb-0">When</label>
                                        <p> {openModal?.data?.when === "before" ? "Before Food" : openModal?.data?.when === "after" ? "After Food" : "N/A"}</p>
                                    </div>
                                    <div className="col-sm-6">
                                        <label className="form-label mb-0">Duration</label>
                                        <p> {openModal?.data?.duration} min</p>
                                    </div>
                                    <div className="col-sm-6">
                                        <label className="form-label mb-0">Remarks</label>
                                        <p> {openModal?.data?.remarks || "N/A"}</p>
                                    </div>
                                </>
                            )}
                            {tab === 2 && (
                                <>
                                    <div className="col-sm-6">
                                        <label className="form-label mb-0">Systolic</label>
                                        <p> {openModal?.data?.sys} mmHg</p>
                                    </div>
                                    <div className="col-sm-6">
                                        <label className="form-label mb-0">Diastolic</label>
                                        <p> {openModal?.data?.dia} mmHg</p>
                                    </div>
                                    <div className="col-sm-6">
                                        <label className="form-label mb-0">Pulse</label>
                                        <p> {openModal?.data?.pulse} BPM</p>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default MeterVitals


